package com.xtream.composeapp.domain.sealed

sealed interface ApiSealed<out T : Any> {


    object Initial : ApiSealed<Nothing>
    object Loading : ApiSealed<Nothing>

    class Success<out T : Any>(val data:T) : ApiSealed<T>
    object Finished : ApiSealed<Nothing>

    class Error(val message: String, val serverMessage: String? =null, val exception: Throwable? = null) : ApiSealed<Nothing>
}
